import api from './api'

export const notificationsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/notifications', { params })
    return res.data
  },

  getUnreadCount: async () => {
    const res = await api.get('/notifications/unread-count')
    return res.data.data
  },

  markAllRead: async () => {
    const res = await api.patch('/notifications/read-all')
    return res.data.data
  },

  markRead: async (id) => {
    const res = await api.patch(`/notifications/${id}/read`)
    return res.data.data
  },

  broadcast: async (data) => {
    const res = await api.post('/notifications/broadcast', data)
    return res.data.data
  },

  deleteAll: async () => {
    await api.delete('/notifications')
  },
}
